// 클립보드 복사 — navigator.clipboard 실패 시 execCommand('copy') fallback
const copyToClipboard = async (text) => {
  // 1차: Async Clipboard API (HTTPS + 권한 있을 때만 동작)
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch { /* fallback */ }
  }
  // 2차: 숨은 textarea + execCommand
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-1000px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
};

export const openMail = async (email) => {
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (isMobile) {
    window.location.href = `mailto:${email}`;
    return { copied: false };
  }
  const url = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
  const copied = await copyToClipboard(email);
  return { copied };
};

export const copyText = copyToClipboard;
